<template>
  <div class="container">
    <div @click="fecharModal" class="modal">
      <transition appear name="slide-resul-volum">
        <div class="modal-container">
          <div class="fecharModal" @click="fecharModal">
            <p>x</p>
          </div>
          <div class="grid-processo">
      <div class="his-bl-table">
        <p>Quantia para aquisição</p>
        <table>
          <thead>
            <tr>
              <th>Descrição</th>
              <th>Qt de Processos</th>
              <th>R$</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Dados dos Processos</td>
              <td>{{qtdProcessos}}</td>
              <td>{{formatarValor(valorTotal)}}</td>
            </tr>
          </tbody>
        </table>
      </div>
        <div class="consulta-form-filtro-btn-block-item">
            <div
              @click ="confirmarAquisicao"
              class="consulta-form-filtro-btn-item"
            >
              <a style="user-select:none">ADQUIRIR DADOS</a>
            </div>
        </div> 
    </div>
    <notifications
      classes="style-notification"
      group="general"
      position="bottom center"
      :ignoreDuplicates="true"
      animation-name="v-fade-left"
    />
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: "ConsultaPreditivo",
  data() {
    return {
    };
  },
  props: ['qtdProcessos','valorTotal'],    
  computed: {},  
  methods: {
    fecharModal() {      
      this.$emit("onFecharRelatorioCustoModal")      
    },
    confirmarAquisicao(){
      this.$emit("onConfirmarAquisicao");      
    },
     formatarValor(valor){
      return parseFloat(valor).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
    },
  }
};
</script>
<style scoped>
p {
  margin: 0;
}
a {
  text-decoration: none;
  color: rgb(197, 193, 193);
}
.container {
  margin: 0 auto;
  max-width: 1480px;
  animation: fadeOut 0.3s;
}
@media screen and (max-width:700px) {
  .container {
    padding: 30px;
  }
}
@keyframes fadeOut {
  from {
    opacity: 0;
    margin-top: -10px;
  }
  to {
    opacity: 1;
    /* margin-top: 17px; */
  }
}
.titulo {
  text-align: center;
  margin-top: 65px;
}
.titulo p {
  font-size: 1.5em;
  font-weight: bold;
}
.bl-processo {
  margin-top: 44px;
}
.input-processo {
  max-width: 200px;
  margin: 0 auto;
}
.titulo-processo > p {
  color: rgb(124, 124, 124);
  font-size: 0.9em;
  margin-bottom: 10px;
}
textarea::-webkit-scrollbar {
  width: 3px;
}

textarea::-webkit-scrollbar-thumb {
  background: #1d375c;
}
textarea {
  outline: none;
  border-color: rgb(197, 193, 193);
  padding: 10px;
  /* resize: none; */
}
.input-processo > input {
  height: 200px;
}
.aviso-input {
  color: rgb(161, 158, 158);
  font-size: 0.7em;
}
.grid-processo {
  margin-top: 60px;
  text-align: center;
}
.grid-processo {
  margin-top: 60px;
  text-align: center;
}
.grid-processo p {
  margin-bottom: 5px;
  font-size: 0.9em;
  font-weight: bold;
  max-width: 665px;
  margin: 0 auto;
}
.his-bl-table {
  display: flex;
  flex-direction: column;
  
}

table {
  max-width: 665px;
  margin: 3% auto;
}
table,
th,
td {
  border: 1px solid black;
  border-collapse: collapse;
  border-color: #a8b2c0;
  padding: 5px;
  font-size: 0.9em;
  text-align: center;
}
th:nth-child(1) {
  width: 300px;
}
th:nth-child(2) {
  width: 200px;
}
th:nth-child(3) {
  width: 100px;
}
th {
  text-align: center;
  height: 33px;
  background-color: #1d375c;
  color: rgb(197, 193, 193);
}
.btn-solic-pred {
  height: 34px;
  width: 148px;
  /* font-size: 0.9em; */
  background-color: #001a3f;
  /* text-align: center;  
  cursor: pointer; */
  margin: 62px auto;
}

.button {
    background-color: #001a3f;
    border: none;        
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 110%;
    margin: 8% 10%;
    cursor: pointer;
    height: 30%;
    width: 30%;
    text-decoration: none;
  color: rgb(197, 193, 193);
}
.btn-solic-dados-label{
  margin: auto;
}
.btn-solic-pred:active {
  background-color: #052f6b;
}
.borderColorRed {
  border-color: red;
}
.slide-resul-volum-enter-active {
  transition: all 0.9s ease;
  z-index: 1;
}
.slide-resul-volum-enter, .slide-resul-volum-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-10px);
  opacity: 0;
}
.modal::before {
  content: "";
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.644);
  /* background: url("../assets/back-desf.png") no-repeat; */
  z-index: 1;
}
.modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 10vh;
  padding: 80px;
}
.modal-container {
  position: relative;
  background-color: #ffffff;
  text-align: center;
  margin-top: 100px;
  width: 646px;
  height: 349px;
  z-index: 2;
  border-radius: 4px;
}
.fecharModal {
  position: absolute;
  top: -4px;
  right: 6px;
  color: #001a3f;
  font-size: 2.3em;
  width: 30px;
  cursor: pointer;
}
.modal-container img:nth-child(2) {
  margin-top: 38px;
}
.modal-container p:nth-child(3),
.modal-container p:nth-child(5) {
  font-size: 1.5em;
  font-weight: bold;
  color: #595959;
}
.modal-container p:nth-child(4) {
  font-size: 3.7em;
  color: #668464;
}
.modal-container p:nth-child(6) {
  background-color: #001a3f;
  margin: 10px auto;
  width: 416px;
  height: 36px;
  color: #c4cad2;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.consulta-form-filtro-btn-block-item {
  display: flex;
  justify-content: center;
  margin-top: 50px;
  margin-bottom: 50px;

}
.consulta-form-filtro-btn-item {
  min-height: 34px;
  max-width: 379px;
  font-size: 0.9em;
  background-color: #001a3f;
  text-align: center;
  padding-top: 7px;
  cursor: pointer;
  width: 200px;
}
/* --- fim modal -- */
</style>
